var map = {
	"./activity.js": "1d4b",
	"./app.js": "d9cd",
	"./appsetting.js": "4395",
	"./audio.js": "64de",
	"./bonus.js": "f39f",
	"./coin.js": "e90f",
	"./directpurchase.js": "0662",
	"./image.js": "2b2a",
	"./marketing.js": "78f4",
	"./member.js": "cd95",
	"./msgaming.js": "cdc1",
	"./news.js": "611b",
	"./notice.js": "5af8",
	"./other.js": "4b98",
	"./precautions.js": "a71b",
	"./product.js": "c2ff",
	"./receiveaward.js": "80a9",
	"./recharge.js": "98f2",
	"./stickers.js": "5722",
	"./third.js": "0980",
	"./website.js": "28d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d307";